import { ensureDate } from '@zapier/date';

import { useCurrentAccount } from '@zapier/upsells/src/hooks';
import { getTaskUpgradeNudgeEligibility } from './getTaskUpgradeNudgeEligibility';

export const useTaskLimitUpgradeNudges = () => {
  const { currentAccount, error, isLoading } = useCurrentAccount();

  const billingPeriodEndDate = currentAccount?.periodEndDate
    ? ensureDate(currentAccount?.periodEndDate)
    : undefined;

  const billingPeriodStartDate = currentAccount?.periodStartDate
    ? ensureDate(currentAccount?.periodStartDate)
    : undefined;

  const {
    isEligibleForLowTaskUpgradeNudge,
    isEligibleForTaskUpgradeNudge,
  } = getTaskUpgradeNudgeEligibility({ account: currentAccount });

  return {
    billingPeriodEndDate,
    billingPeriodStartDate,
    error,
    isEligibleForLowTaskUpgradeNudge,
    isEligibleForTaskUpgradeNudge,
    isLoading,
  };
};
